import { useCallback, useEffect } from "react"
import { Block, LabelMedium, LabelSmall, ModalBody } from "@mezo-org/mezo-clay"

import { ComponentStepProps } from "#/ui/Modal"

import Pools from "../../Pools"

import { useAddLiquidityFlowContext } from "./AddLiquidityFlowContext"

const columns = [
  "Select pools",
  "TVL",
  <Block>
    <LabelSmall color="contentSecondary">Total</LabelSmall>
    <LabelSmall color="contentSecondary">Rewards</LabelSmall>
  </Block>,
  "",
]

export default function SelectPoolStep({
  onClickContinue,
}: ComponentStepProps) {
  const { setPoolId, initialSelectedPoolId } = useAddLiquidityFlowContext()

  const setPool = useCallback(
    (poolId: string) => {
      setPoolId(poolId)
      onClickContinue()
    },
    [setPoolId, onClickContinue],
  )

  useEffect(() => {
    if (!initialSelectedPoolId) return

    setPool(initialSelectedPoolId)
  }, [setPool, initialSelectedPoolId])

  const onPoolClick = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    const poolId = event.currentTarget.dataset.poolid

    if (!poolId) throw new Error("Pool id not available")

    setPool(poolId)
  }

  return (
    <ModalBody
      $style={() => ({
        display: "flex",
        flexDirection: "column",
        marginBottom: "auto",
      })}
    >
      <LabelMedium color="contentPrimary" marginBottom="scale800">
        Available pools
      </LabelMedium>
      <Pools
        columns={columns}
        onPoolClick={onPoolClick}
        overrides={{
          Table: {
            style: ({ $theme }) => ({
              borderSpacing: `0 ${$theme.sizing.scale300}`,
            }),
          },
          TableHeadCell: {
            style: ({ $theme }) => ({
              paddingRight: $theme.sizing.scale300,
              paddingLeft: $theme.sizing.scale300,
              paddingBottom: 0,
              "th:nth-child(3)": { textAlign: "right" },
            }),
          },
          TableBodyCell: {
            style: ({ $theme }) => ({
              border: `1px solid ${$theme.colors.borderOpaque}`,
              padding: `${$theme.sizing.scale800} ${$theme.sizing.scale300}`,
              borderLeft: "none",
              borderRight: "none",
              "td:nth-child(3) > div > div": {
                marginLeft: "auto",
              },
              "td:first-child": {
                borderRight: "none",
                borderLeft: `1px solid ${$theme.colors.borderOpaque}`,
              },
              "td:last-child": {
                borderLeft: "none",
                borderRight: `1px solid ${$theme.colors.borderOpaque}`,
              },
            }),
          },
        }}
      />
    </ModalBody>
  )
}
